/* 🤖 this file was generated by svg-to-ts */
export const emperorIconContentFilter: {
  name: 'content_filter';
  data: string;
} = {
  name: 'content_filter',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M18 2H6c-1.104 0-2 .89-2 2v4c0 .25.09.51.29.7l4.707 4.708v7.58c0 .4.24.76.61.92 .12.05.25.07.38.07 .26 0 .516-.11.7-.3l4-4c.18-.19.29-.45.29-.71v-3.59l4.7-4.71c.19-.2.29-.45.29-.71v-4c0-1.11-.9-2-2-2Zm-4.71 10.293c-.19.18-.3.44-.3.7v3.58l-2 2v-5.59c0-.27-.11-.52-.3-.71l-4.71-4.71v-3.59h12v3.58l-4.71 4.7Z"/></svg>`
};
